<template>
  <div>
    <el-form label-width="80px" size="mini">
      <el-tabs :style="{height: docHeight+'px'}" tab-position="left" class="my-tab">
        <el-tab-pane :label="msg('电子秤设置')" v-if="hasPermission('userSetting:scale')">
          <UserSettingScale></UserSettingScale>
        </el-tab-pane>
        <el-tab-pane :label="msg('货单样式设置')" v-if="hasPermission('userSetting:ticket')">
          <UserSettingInvoiceStyle></UserSettingInvoiceStyle>
        </el-tab-pane>
        <el-tab-pane :label="msg('计重策略')" v-if="hasPermission('userSetting:weight')">
          <UserSettingWeighing></UserSettingWeighing>
        </el-tab-pane>
        <el-tab-pane :label="msg('材积计算')" v-if="hasPermission('userSetting:weight')">
          <UserSettingMeasurement></UserSettingMeasurement>
        </el-tab-pane>
        <el-tab-pane :label="msg('虾皮发货地址')" v-if="hasPermission('userSetting:printWarn')">
          <UserSettingShippingAddress></UserSettingShippingAddress>
        </el-tab-pane>
        <el-tab-pane :label="msg('自动识别设置')" v-if="hasPermission('userSetting:printWarn')">
          <UserSettingRecognition></UserSettingRecognition>
        </el-tab-pane>
        <el-tab-pane :label="msg('航空报表设置')" v-if="hasPermission('stock:downloadHangkong')">
          <UserSettingReportHangkong></UserSettingReportHangkong>
        </el-tab-pane>
        <el-tab-pane :label="msg('清关报表设置')" v-if="hasPermission('stock:downloadQingguan')">
          <UserSettingReportQingguan></UserSettingReportQingguan>
        </el-tab-pane>
        <el-tab-pane :label="msg('派件报表设置')" v-if="hasPermission('stock:downloadHeimao')">
          <UserSettingReportHeimao></UserSettingReportHeimao>
        </el-tab-pane>
        <el-tab-pane :label="msg('新竹派件设置')" v-if="hasPermission('stock:downloadHeimao')">
          <UserSettingReportXinZhu></UserSettingReportXinZhu>
        </el-tab-pane>
        <!-- v-if="hasPermission('userSetting:strongPwd')" -->
        <el-tab-pane label="资料安全密码">
          <UserSettingStrongPwd></UserSettingStrongPwd>
        </el-tab-pane>
        <el-tab-pane label="运输方式" v-if="hasPermission('userSetting:weight')">
          <UserSettingTransportation></UserSettingTransportation>
        </el-tab-pane>
        <!-- <el-tab-pane label="面单服务商" v-if="hasPermission('userSetting:printWarn')">
          <UserSettingPageSender></UserSettingPageSender>
        </el-tab-pane>  -->
      </el-tabs>
    </el-form>
  </div>
</template>

<script>
import UserSettingScale from "@/views/sys/UserSettingScale.vue";
import UserSettingInvoiceStyle from "@/views/sys/UserSettingInvoiceStyle.vue";
import UserSettingWeighing from "@/views/sys/UserSettingWeighing.vue";
import UserSettingShippingAddress from "@/views/sys/UserSettingShippingAddress.vue";
import UserSettingPageSender from "@/views/sys/UserSettingPageSender.vue";
import UserSettingMeasurement from "@/views/sys/UserSettingMeasurement.vue";
import UserSettingRecognition from "@/views/sys/UserSettingRecognition.vue";
import UserSettingReportHangkong from "@/views/sys/UserSettingReportHangkong.vue";
import UserSettingReportQingguan from "@/views/sys/UserSettingReportQingguan.vue";
import UserSettingReportHeimao from "@/views/sys/UserSettingReportHeimao.vue";
import UserSettingReportXinZhu from "@/views/sys/UserSettingReportXinZhu.vue";
import UserSettingStrongPwd from "@/views/sys/UserSettingStrongPwd.vue";
import UserSettingTransportation from "@/views/sys/UserSettingTransportation.vue";

export default {
  name: "UserSetting",
  components: {
    UserSettingTransportation,
    UserSettingStrongPwd,
    UserSettingReportXinZhu,
    UserSettingReportHeimao,
    UserSettingReportQingguan,
    UserSettingReportHangkong,
    UserSettingRecognition,
    UserSettingMeasurement,
    UserSettingShippingAddress,
    UserSettingWeighing,
    UserSettingInvoiceStyle,
    UserSettingScale,
  },
  computed: {
    docHeight: {  //表格的高度
      get() {
        var height = this.$store.state.docHeight;
        return height - 120;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.pts-checkbox {
  margin: 5px 15px 5px 0px !important;
}

.my-tab {
  margin: 10px 15px;
  overflow: auto;
}

.page-tpl /deep/ .print-wrap {
  margin-left: -50px;
  transform: scale(0.75);
  width: 360px;
}

.row-wrap {
  overflow-y: auto;
  height: calc(100vh - 185px);
}
</style>